// Remembers the sector (and its menu item) the user is viewing, so the
// dashboard and the profile/settings pages show the same sidebar.
const active_sector_storage_key = "bolide_active_sector";

export function get_active_sector() {
  return JSON.parse(sessionStorage.getItem(active_sector_storage_key) || "null");
}

export function set_active_sector(sector_id, menu_item) {
  sessionStorage.setItem(active_sector_storage_key, JSON.stringify({
    id: sector_id,
    menuItem: menu_item
  }));
}

export function clear_active_sector() {
  sessionStorage.removeItem(active_sector_storage_key);
}
